/*
    Redirect the user to corresponding checkout page according to their status
 */
define('shared/initializer/form/adapters/mixins/CheckoutFlowControllable',[
    'shared/initializer/checkout/redirector',
    'shared/lib/RSVP'
], 
function (redirector, RSVP) {
    'use strict';

    var hasStartedOnCurrentPage = false;

    function Ctor() { }
    
    Ctor.prototype.doPageLoad = function(){
        if (this.options.checkoutFlowControl && this.options.checkoutFlowControl.enable === false) {
            return RSVP.resolve();
        }
        if (hasStartedOnCurrentPage) {
            return RSVP.resolve();
        }
        else {
            hasStartedOnCurrentPage = true;
            return redirector.redirect(this.options);
        }
    };

    return Ctor;
});
